/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ACCOUNTS,
  ADD_ACCOUNT,
  ADD_BANK_TO_ASSET,
  REMOVE_BANK_FROM_ASSET,
  // RESET,
  REMOVE_ACCOUNT,
  UNLINK_ASSETS,
  GET_ACCOUNT_DETAIL,
  // GET_ACCOUNTS_SUCCESS,
  // GET_ACCOUNTS_FAILURE,
} from "../actionTypes";

export const getAccounts = (dispatch) => {
  dispatch({
    type: GET_ACCOUNTS,
  });
};

export const addAccount = (plaidData, dispatch) => {
  dispatch({
    type: ADD_ACCOUNT,
    payload: plaidData,
  });
};

export const addBankToAsset = (data, dispatch) => {
  dispatch({
    type: ADD_BANK_TO_ASSET,
    payload: data,
  });
};

export const removeBankFromAsset = (data, dispatch) => {
  dispatch({
    type: REMOVE_BANK_FROM_ASSET,
    payload: data,
  });
};

// export const resetState = (dispatch) => {
//     dispatch({
//         type:RESET,
//     });
// }

export const removeAccount = (data, dispatch) => {
  dispatch({
    type: REMOVE_ACCOUNT,
    payload: data,
  });
};

export const unlinkAssets = (data, dispatch) => {
  dispatch({
    type: UNLINK_ASSETS,
    payload: data,
  });
};

export const getAccountDetail = (data, dispatch) => {
  dispatch({
    type: GET_ACCOUNT_DETAIL,
    payload: data,
  });
};
